import { PricingPlanContent } from '@anm/api/modules/pricing';
import { SubscriptionDetails, SubscriptionPeriod } from '@anm/api/modules/subscription';
import { UserSubscriptionDetails } from '@anm/api/modules/user';
import { PricingTablePlan } from '@anm/components/pricing/PricingTable';
import findSubscription from '@anm/helpers/subscription/findSubscription';
import { UserTeamPermission } from 'types/user';

import calcPlanContent from './calcPlanContent';

type CalcPricingPlanDataProps = {
  view: SubscriptionPeriod;
  planContentList: PricingPlanContent[];
  subscriptionList: SubscriptionDetails[];
  teamPermissions?: UserTeamPermission;
  discount?: number;
  currentSubscription?: UserSubscriptionDetails;
};

const calcPricingPlanData = ({
  view,
  discount,
  planContentList,
  subscriptionList,
  teamPermissions,
  currentSubscription
}: CalcPricingPlanDataProps): PricingTablePlan[] => {
  return planContentList.reduce((acc, planContent) => {
    const subscription = findSubscription(subscriptionList)(planContent.id);

    const content =
      subscription &&
      calcPlanContent({
        view,
        discount,
        teamPermissions,
        planContent,
        subscription,
        currentSubscription
      });

    content && acc.push(content);

    return [...acc];
  }, [] as PricingTablePlan[]);
};

export default calcPricingPlanData;
